var _path, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCrossed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61317 8.97543C1.52238 8.83167 1.47698 8.75979 1.45157 8.64892C1.43248 8.56565 1.43248 8.43431 1.45157 8.35104C1.47698 8.24017 1.52238 8.16829 1.61317 8.02453C2.36344 6.83654 4.59669 3.83331 8.00002 3.83331C11.4034 3.83331 13.6366 6.83654 14.3869 8.02453C14.4777 8.16829 14.5231 8.24017 14.5485 8.35104C14.5676 8.43431 14.5676 8.56565 14.5485 8.64892C14.5231 8.75979 14.4777 8.83167 14.3869 8.97543C13.6366 10.1634 11.4034 13.1666 8.00002 13.1666C4.59669 13.1666 2.36344 10.1634 1.61317 8.97543Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.3391,
    y1: 2.3674,
    x2: 1.33914,
    y2: 14.3674,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5C9.10457 10.5 10 9.60457 10 8.5C10 7.39543 9.10457 6.5 8 6.5C6.89543 6.5 6 7.39543 6 8.5C6 9.60457 6.89543 10.5 8 10.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossed);
export default __webpack_public_path__ + "static/media/eye-crossed.8a537db11d63fb6609ac11bdabb43c72.svg";
export { ForwardRef as ReactComponent };